import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-spinner-cover',
	templateUrl: './spinner-cover.component.html',
})
export class SpinnerCoverComponent implements OnInit {
	constructor(private dialogRef: MatDialogRef<SpinnerCoverComponent>) {}

	ngOnInit(): void {}
}
